import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Toolbar.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'

interface ToolbarMenuProps {
  title: string | React.ReactNode
  children: React.ReactNode
  action?: React.ReactNode
  inDesigner?: boolean
}

export const ToolbarMenu = ({ title, children, action, inDesigner }: ToolbarMenuProps) => {
  return (
    <div className={cx(Styles.toolbarMenu, { [Styles.inDesigner]: inDesigner })}>
      <div className={Styles.toolbarMenuHeader}>
        {inDesigner ? <Heading level={5}>{title}</Heading> : <Text variant="smallList">{title}</Text>}
        {action}
      </div>
      {children}
    </div>
  )
}
